import { PURGE } from "redux-persist";
import {
  FETCH_BASIC_CONFIG_DATA,
  FETCH_BASIC_CONFIG_SUCCESS,
  FETCH_BASIC_CONFIG_FAILURE,
  CHANGE_THEME,
  GET_MASTER_LIST,
  SET_USER_DETAILS,
  SET_USER_DETAILS_SUCCESS,
  GET_MESSAGE_LIBRARY,
  GET_MESSAGE_LIBRARY_SUCCESS,
  GET_MESSAGE_LIBRARY_FAILURE,
  RESET_STATE,
  CLEAR_CACHE,
  UPDATE_USERS_LIST,
  SET_CONSOLE_DATA,
  SET_UTS,
  SET_MICRO_SERVICE_FLAG,
} from "../../constants/action";

export const fetchBasicConfig = (data) => ({
  type: FETCH_BASIC_CONFIG_DATA,
  payload: data,
});

export const fetchBasicConfigSuccess = (data) => ({
  type: FETCH_BASIC_CONFIG_SUCCESS,
  payload: data,
});

export const fetchBasicConfigFailure = (error) => ({
  type: FETCH_BASIC_CONFIG_FAILURE,
  payload: error,
});

export const changeTheme = (data) => ({
  type: CHANGE_THEME,
  payload: data,
});

export const getMasterList = (data) => ({
  type: GET_MASTER_LIST,
  payload: data,
});

export const setUserDetails = () => ({ type: SET_USER_DETAILS });
export const setUserDetailsSuccess = (data) => ({
  type: SET_USER_DETAILS_SUCCESS,
  payload: data,
});
export const clearPersistedStore = () => ({
  type: PURGE,
  key: "root", // Your persistor key, defaults to 'root'
  result: () => null, // Custom result creator, defaults to returning null
});
export const resetState = () => ({
  type: RESET_STATE,
});
export const clearCache = () => ({
  type: CLEAR_CACHE,
});

export const getMessageLibrary = (data) => ({
  type: GET_MESSAGE_LIBRARY,
  payload: data,
});
export const getMessageLibrarySuccess = (data) => ({
  type: GET_MESSAGE_LIBRARY_SUCCESS,
  payload: data,
});
export const getMessageLibraryFailure = (error) => ({
  type: GET_MESSAGE_LIBRARY_FAILURE,
  payload: error,
});
export const updateUsersList = (data) => ({
  type: UPDATE_USERS_LIST,
  payload: data,
});

export const setConsoleData = (data) => ({
  type: SET_CONSOLE_DATA,
  payload: data,
});

export const setUTS = (data) => ({
  type: SET_UTS,
  payload: data,
});

export const setIsMicroService = (data) => ({
  type: SET_MICRO_SERVICE_FLAG,
  payload: data,
});
